import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { Datepicker, InfoMessage } from '@whitbread-eos/atoms';
import { add, differenceInDays } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BookingDatepickerComponent(_ref) {
  var _inputPlaceholderDate, _partialTranslations$, _partialTranslations$2;
  var maxNumberOfNights = _ref.maxNumberOfNights,
    maxArrivalDate = _ref.maxArrivalDate,
    displayDateFormat = _ref.displayDateFormat,
    onSelectDates = _ref.onSelectDates,
    inputPlaceholderDatepicker = _ref.inputPlaceholderDatepicker,
    defaultStartDate = _ref.defaultStartDate,
    datepickerStyles = _ref.datepickerStyles,
    defaultEndDate = _ref.defaultEndDate,
    partialTranslations = _ref.partialTranslations,
    locale = _ref.locale,
    showErrorMessage = _ref.showErrorMessage,
    errorMessage = _ref.errorMessage,
    isError = _ref.isError,
    isLessThanSm = _ref.isLessThanSm,
    isDatePickerFocus = _ref.isDatePickerFocus,
    displayDatesNotification = _ref.displayDatesNotification,
    disableFlip = _ref.disableFlip;
  var _useState = useState(add(new Date(), {
      days: maxArrivalDate
    })),
    _useState2 = _slicedToArray(_useState, 2),
    maxDate = _useState2[0],
    setMaxDate = _useState2[1];
  var displayNewDatesNotification = displayDatesNotification && !defaultStartDate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return _jsxs(Box, _objectSpread(_objectSpread({
    position: "relative"
  }, datepickerStyles.bookingDatepickerSize), {}, {
    children: [_jsx(Datepicker, _objectSpread(_objectSpread({}, locale === 'de' ? {
      locale: 'de'
    } : {}), {}, {
      minDate: new Date(),
      maxDate: maxDate,
      inputPlaceholder: (_inputPlaceholderDate = inputPlaceholderDatepicker === null || inputPlaceholderDatepicker === void 0 ? void 0 : inputPlaceholderDatepicker.toString()) !== null && _inputPlaceholderDate !== void 0 ? _inputPlaceholderDate : "".concat(partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$ = partialTranslations.content) === null || _partialTranslations$ === void 0 || (_partialTranslations$ = _partialTranslations$.global) === null || _partialTranslations$ === void 0 ? void 0 : _partialTranslations$.today, " | ").concat(partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$2 = partialTranslations.content) === null || _partialTranslations$2 === void 0 || (_partialTranslations$2 = _partialTranslations$2.global) === null || _partialTranslations$2 === void 0 ? void 0 : _partialTranslations$2.tomorrow),
      dateFormat: 'dd MMM yyyy',
      displayDateFormat: displayDateFormat,
      labels: {
        resetButtonLabel: partialTranslations.datePicker.reset,
        doneButtonLabel: partialTranslations.content.global.done,
        todayLabel: partialTranslations.content.global.today,
        tomorrowLabel: partialTranslations.content.global.tomorrow,
        checkoutLabel: partialTranslations.datePicker.checkOut,
        checkInLabel: t('dashboard.bookings.checkIn')
      },
      hasFooter: true,
      selectsRange: true,
      datepickerStyles: datepickerStyles,
      onSelectDates: handleSelectDates,
      onReset: handleReset,
      defaultStartDate: defaultStartDate,
      defaultEndDate: defaultEndDate,
      isError: isError,
      isDatePickerFocus: isDatePickerFocus,
      displayDatesNotification: displayDatesNotification,
      disableFlip: disableFlip
    })), !isLessThanSm && showErrorMessage && errorMessage && _jsx(InfoMessage, {
      infoMessage: errorMessage,
      otherStyles: _objectSpread({}, alertStyles)
    }), displayNewDatesNotification && _jsx(InfoMessage, {
      infoMessage: t('ccui.search.enterDates'),
      otherStyles: _objectSpread({}, newDatesNotifStyles),
      variant: 'Info'
    })]
  }));
  function handleSelectDates(dates) {
    var _ref2 = dates,
      _ref3 = _slicedToArray(_ref2, 2),
      arrivalDate = _ref3[0],
      departureDate = _ref3[1];
    onSelectDates === null || onSelectDates === void 0 || onSelectDates(dates);
    if (departureDate) {
      setMaxDate(add(new Date(), {
        days: maxArrivalDate
      }));
      return;
    }
    if (arrivalDate && differenceInDays(add(new Date(), {
      days: maxArrivalDate
    }), arrivalDate) < maxNumberOfNights) {
      setMaxDate(add(new Date(maxDate), {
        days: 1
      }));
      return;
    }
    arrivalDate && setMaxDate(add(new Date(arrivalDate), {
      days: maxNumberOfNights
    }));
  }
  function handleReset() {
    setMaxDate(add(new Date(), {
      days: maxArrivalDate
    }));
    onSelectDates === null || onSelectDates === void 0 || onSelectDates([null, null]);
  }
}
var alertStyles = {
  w: {
    base: 'full',
    sm: '20rem',
    lg: 'full'
  },
  zIndex: 100
};
var newDatesNotifStyles = {
  backgroundColor: 'tooltipInfo',
  w: {
    base: 'full',
    sm: '20rem',
    lg: 'full'
  },
  zIndex: 100,
  _before: {
    content: '" "',
    position: 'absolute',
    top: '-0.15rem',
    left: 'xs',
    width: '1.5rem',
    height: '0.75rem',
    zIndex: '-1',
    transform: 'rotate(-45deg)',
    bgColor: 'tooltipInfo',
    borderRadius: '3'
  }
};